import React, { useState } from 'react';
import Footer from "../components/Footer";
import Header from "../components/Header";
import '../styles/FAQ.css';

const faqData = [
  {
    question: 'What is CyberKon?',
    answer:
      'CyberKon is a construction-tech using web tools to improve estimation, accuracy, and efficiency in the construction industry.',
  },
  {
    question: 'What services do you offer?',
    answer:
      'We currently provide automated construction material estimation tools for concrete, steel, mortar, blocks, and formwork. Additional services are in development.',
  },
  {
    question: 'Is roof estimation available?',
    answer:
      'Not yet, but it is currently being developed and will be integrated into the platform soon.',
  },
  {
    question: 'Where are you based?',
    answer:
      'We are based in Osun State, Nigeria.',
  },
  {
    question: 'Can I use your tools for free?',
    answer:
      'Currently, the estimation platform is publicly accessible, though premium features may be added in the future.',
  },
  {
    question: 'How can I contact you?',
    answer:
      'You can reach us directly via the phone number listed on our About Us page or use the contact form on the Contact Us page.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <Header/>
      <h1>Frequently Asked Questions</h1>
      {faqData.map((item, index) => (
        <div key={index} className="faq-item">
          <div className="faq-question" onClick={() => toggleAnswer(index)}>
            {item.question}
          </div>
          {openIndex === index && <div className="faq-answer">{item.answer}</div>}
        </div>
      ))}
      <Footer/>
    </div>
  );
};

export default FAQ;
